import { render, staticRenderFns } from "./AttributeSetEditModalKeys.vue?vue&type=template&id=e4b7c768&scoped=true&"
import script from "./AttributeSetEditModalKeys.vue?vue&type=script&lang=js&"
export * from "./AttributeSetEditModalKeys.vue?vue&type=script&lang=js&"
import style0 from "./AttributeSetEditModalKeys.vue?vue&type=style&index=0&id=e4b7c768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b7c768",
  null
  
)

export default component.exports